var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "m-subheader" }, [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("div", { staticClass: "mr-auto" }, [
          _c(
            "ul",
            { staticClass: "m-subheader__breadcrumbs m-nav m-nav--inline" },
            [
              _c(
                "li",
                { staticClass: "m-nav__item" },
                [
                  _c("router-link", { attrs: { to: { name: "home" } } }, [
                    _c("span", { staticClass: "m-nav__link-text" }, [
                      _c("i", { staticClass: "m-nav__link-icon la la-home" })
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__separator" }, [
                _vm._v("\n\t\t  \t\t\t\t>\n\t\t  \t\t\t")
              ]),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "m-nav__item" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "adminControlPoints" } } },
                    [
                      _c("span", { staticClass: "m-nav__link-text" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm._f("titleize")(
                                _vm._f("translate")("control_points")
                              )
                            ) +
                            "\n                        "
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__separator" }, [
                _vm._v("\n\t\t  \t\t\t\t>\n\t\t  \t\t\t")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__item" }, [
                _c("span", { staticClass: "m-nav__link-text" }, [
                  _vm._v(
                    "\n\t\t  \t\t\t\t\t" +
                      _vm._s(
                        _vm._f("titleize")(_vm._f("translate")("cameras_list"))
                      ) +
                      "\n\t\t  \t\t\t\t"
                  )
                ])
              ])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "m-content", attrs: { id: "content" } }, [
      _c(
        "div",
        { staticClass: "m-portlet m-portlet--mobile" },
        [
          _c("div", { staticClass: "m-portlet__head" }, [
            _c("div", { staticClass: "m-portlet__head-caption" }, [
              _c("div", { staticClass: "m-portlet__head-title" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("h3", { staticClass: "m-portlet__head-text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("cameras"))
                      ) +
                      "\n              "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "m-portlet__head-tools" }, [
              _c("ul", { staticClass: "m-portlet__nav" }, [
                _c("li", { staticClass: "m-portlet__nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-success m-btn m-btn--icon",
                      attrs: {
                        href: "#",
                        "data-toggle": "modal",
                        "data-backdrop": "static",
                        "data-keyboard": "false",
                        "data-target": "#new_camera_modal"
                      },
                      on: {
                        click: function($event) {
                          return _vm.setStatusCameraModal(true)
                        }
                      }
                    },
                    [
                      _c("span", [
                        _c("i", { staticClass: "fa fa-plus" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "\n                      " +
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("create_camera")
                                )
                              ) +
                              "\n                    "
                          )
                        ])
                      ])
                    ]
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "m-portlet__body" },
            [
              _c("div", { staticClass: "form-group m-form__group row" }, [
                _c("div", { staticClass: "col-lg-3" }, [
                  _c("label", { attrs: { for: "control_point" } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(
                          _vm._f("translate")("control_point")
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.control_point,
                          expression: "control_point"
                        }
                      ],
                      staticClass: "form-control m_selectpicker",
                      attrs: {
                        name: "type",
                        id: "type",
                        title: _vm._f("capitalize")(
                          _vm._f("translate")("select_control_point")
                        )
                      },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.control_point = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.control_points, function(cp) {
                      return _c(
                        "option",
                        { key: cp.id, domProps: { value: cp.id } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(_vm._f("translate")(cp.name))
                            )
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]),
              _vm._v(" "),
              _c("s-datatable", {
                attrs: { config: _vm.datatable },
                scopedSlots: _vm._u([
                  {
                    key: "state",
                    fn: function(props) {
                      return _c("div", {}, [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.cameraStatus(
                                  props.row.id,
                                  props.row.state == 1 ? 0 : 1
                                )
                              }
                            }
                          },
                          [
                            props.row.state == 1
                              ? _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.messageStateTooltip,
                                        expression: "messageStateTooltip"
                                      }
                                    ],
                                    staticClass:
                                      "m-badge m-badge--success m-badge--wide"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm._f("translate")("active")
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.messageStateTooltip,
                                        expression: "messageStateTooltip"
                                      }
                                    ],
                                    staticClass:
                                      "m-badge m-badge--danger m-badge--wide"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm._f("translate")("inactive")
                                        )
                                      )
                                    )
                                  ]
                                )
                          ]
                        )
                      ])
                    }
                  },
                  {
                    key: "actions",
                    fn: function(props) {
                      return _c("div", {}, [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.messageEditTooltip,
                                expression: "messageEditTooltip"
                              }
                            ],
                            staticClass:
                              "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit",
                            attrs: {
                              href: "#",
                              "data-toggle": "modal",
                              "data-backdrop": "static",
                              "data-keyboard": "false",
                              "data-target": "#new_camera_modal"
                            },
                            on: {
                              click: function($event) {
                                return _vm.editCamera(props.row)
                              }
                            }
                          },
                          [_c("i", { staticClass: "la la-edit" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.messageTestTooltip,
                                expression: "messageTestTooltip"
                              }
                            ],
                            staticClass:
                              "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit",
                            attrs: {
                              href: "#",
                              "data-toggle": "modal",
                              "data-backdrop": "static",
                              "data-keyboard": "false",
                              "data-target": "#test_camera_modal"
                            },
                            on: {
                              click: function($event) {
                                return _vm.testCam(props.row)
                              }
                            }
                          },
                          [_c("i", { staticClass: "la la-camera" })]
                        )
                      ])
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "s-modal",
            {
              attrs: {
                id: "new_camera_modal",
                title: _vm._f("capitalize")(
                  _vm._f("translate")(
                    _vm.edit ? "edit_camera" : "create_camera"
                  )
                )
              }
            },
            [
              _c("s-new-camera", {
                attrs: { slot: "body", data_send: _vm.data_modal },
                slot: "body"
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "s-modal",
            {
              attrs: {
                id: "test_camera_modal",
                title: _vm._f("capitalize")(_vm._f("translate")("view_camera"))
              }
            },
            [
              _c("s-test-camera", {
                attrs: { slot: "body", data_send: _vm.test_data_modal },
                slot: "body"
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-portlet__head-icon" }, [
      _c("i", { staticClass: "la la-camera-retro" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d797dae4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d797dae4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/cameras/Camera.vue
// module id = 630
// module chunks = 0 1 56